import {
  FlexibleBlockBrickImage,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateHeroHeadline,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getHeroHeadlineBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateHeroHeadline>[] => {
  const brickTitle: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Title',
    text: 'Sync. Strategize. Win',
    placeholder: 'Here, you can add title',
    className: ['font-extrabold', 'text-5xl', 'lg:text-7xl', 'break-words'],
    theme: { text: { main: PortalTextType.HERO_TEXT } },
  };

  const brickImage: FlexibleBlockBrickImage = {
    ...brickCommon,
    brickType: 'image',
    brickName: 'Bottom image',
    switchable: true,
    src: '/assets/img/blocks/headline/headline.png',
    className: ['max-w-3xl', 'mx-auto', 'max-h-72'],
  };

  return [
    {
      title: 'Headline & Image',
      template: { type: 'hero-headline', view: 'basic' },
      bricks: [
        { ...brickTitle, index: 0 },
        { ...brickImage, index: 1 },
      ],
      className: ['justify-around', 'min-h-72', 'text-center'],
      wrapper: getWrapperProps('none'),
    },
  ];
};
